import React from 'react';
import styles from './index.modules.scss';
import { Menu as MMenu } from '@mantine/core';
import { Text } from '@shakkerai/pro-components';

export const Menu = (props) => {
  const { children, width = 150, ...rest } = props;
  return (
    <MMenu shadow="md" position="bottom-end" width={width} classNames={styles.menu} {...rest}>
      {children}
    </MMenu>
  );
};

export const MenuItem = (props) => {
  const { children, ...resetProps } = props;

  return (
    <MMenu.Item {...resetProps} className={styles.menuItem} component={Text}>
      {children}
    </MMenu.Item>
  );
};

export const MenuTarget = (props) => {
  const { children, ...resetProps } = props;
  return <MMenu.Target {...resetProps}>{children}</MMenu.Target>;
};
export const MenuDropdown = (props) => {
  const { children, ...resetProps } = props;
  return (
    <MMenu.Dropdown className={styles.dropdown} {...resetProps}>
      {children}
    </MMenu.Dropdown>
  );
};
